// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"554f735b","32":"8e358ec6","64":"7fcf880d","216":"10e30b62","411":"59e704b6","453":"08f68fb1","526":"4fa9cf5a","549":"d450999a","702":"4482d4fb","947":"5e6c1c44"}[chunkId] + ".chunk.js";
};